import React from 'react'
import { Table, Space, Tag, Button, Skeleton } from 'antd'
import Title from '../../system/title/Title'
import useSWR from 'swr'
import ApiManager from '../../../business/services/ApiManager';
import { toDate } from '../../../helpers/dateFormatHelper';
import { DownloadOutlined } from '@ant-design/icons';
import Section from '../section/Section';

const BillList = () => {
    const { data, error } = useSWR(['Invoices'], (_key) => ApiManager.customers.getInvoices())

    const columns = [
        {
            title: 'Montant',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount: number) => (
                <Space size="small">
                    {amount/100} €
                </Space>
            )
        },
        {
            title: '',
            dataIndex: 'status',
            key: 'status',
            render: (status: string) =>
            status === "paid" ? (
                    <Tag color="green">PAYÉ</Tag>
                ) : (
                    <Tag color="red">NON PAYÉ</Tag>
                )
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (id: React.ReactNode) => (
                <Space size="small">
                     {id}
                </Space>
            )
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (date: string) => (
                <Space size="small">
                     {toDate(date)}
                </Space>
            )
        },
        {
            title: '',
            dataIndex: 'pdfLink',
            key: 'pdfLink',
            render: (pdfLink: string) => (
                <Space size="small">
                     <Button href={pdfLink} icon={<DownloadOutlined />}/>
                </Space>
            )
        },
    ]

    if (error) return <div>failed to load</div>
    if (!data) return <Skeleton active />

    return (
        <Section title="Factures">
            <Table columns={columns} dataSource={data.data} />
        </Section>
    )
}

export default BillList